export default __webpack_public_path__ + "static/media/small_document.e2a0bfbc.svg";